import { Icon } from '@platform/components';
import { useState } from 'react';

export const EmailCopyButton = ({ email }: { email: string }) => {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type='button'
      aria-label='Copy email'
      onClick={(e) => {
        e.stopPropagation();
        void navigator.clipboard.writeText(email);
        setCopied(true);
        setTimeout(() => setCopied(false), 1200);
      }}
      className='inline-flex items-center gap-1.5 text-xs text-gray-400 hover:text-avatar-text'
    >
      {email}
      <span className='inline-flex h-4 w-4 items-center justify-center'>
        <Icon type={copied ? 'check' : 'copy-01'} size='14' />
      </span>
    </button>
  );
};
